<app-links-item [color]="color" [icon]="icon" [labels]="indicator.labels" [uid]="indicator.uid">
  <div app-links-item-content-description>
    <app-tags-icons-list [tags]="indicator.tags"></app-tags-icons-list>
  </div>
  <div app-links-item-content-option>
    <app-links-item-option class="d-block mx-1" [symbol]="'check'" [selected]="isSelected" (sendSelected)="receiveSelected()"></app-links-item-option>
  </div>
</app-links-item>